import { MessageHandlerStateWrapper } from "./MessageHandlerStateWrapper";
export class JsMessageHandler {
    constructor(src) {
        this.name = src.name;
        this.inner = src.handler;
    }
    handle(state, properties) {
        return this.inner(state, properties).then((mh) => new MessageHandlerStateWrapper(mh));
    }
}
//# sourceMappingURL=JsMessageHandler.js.map